import { G } from '@mobily/ts-belt';
import { useGetIdentity } from 'react-admin';

import { useCompanyId } from '@Hooks/useCompanyId';

export function useCompanyDetails() {
  const companyId = useCompanyId();
  const { data: identity } = useGetIdentity();

  if (G.isNullable(identity) || G.isNullable(companyId)) {
    return null;
  }

  return identity.companies.find((company) => company.id === companyId) ?? null;
}

export type UseCompanyDetailsReturnType = ReturnType<typeof useCompanyDetails>;
